"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultAccountInfoState = void 0;
var LoginState_1 = require("@/pages/common/states/LoginState");
var AccountInfoState_1 = require("@/pages/accountInfo/states/AccountInfoState");
var LayoutState_1 = require("@/pages/common/states/LayoutState");
var SfilterPriceGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterPriceGroup");
var LayoutState_init_1 = require("@/pages/common/states/LayoutState.init");
exports.defaultAccountInfoState = {
    nameTitle: 'Personal Information',
    nameCaption: 'Update your personal information ',
    isLoading: false,
    isEditing: false,
    dialCodes: LayoutState_init_1.defaultLayoutState.dialCodes,
    account: {
        salutation: LoginState_1.Salutation.MR,
        firstname: 'john',
        lastname: 'doe',
        email: 'roy.cheung@okay.com',
        from: AccountInfoState_1.RegisterFrom.NONE,
        phone: {
            code: '',
            body: '',
        },
        language: LayoutState_1.Language.ZH_HK,
        currency: SfilterPriceGroup_1.SfilterCurrency.USD,
        birthdayDate: '1753-1-01',
        registerDate: '2018-01-14',
    },
    tForm: {
        email: 'Email',
        required: 'Required',
        emailFormat: 'Invalid Email Format',
        nameSubmit: 'Submit',
        placeholderEmail: 'Email (eg. john.doe@okay.com)',
        placeholderFirstName: 'First Name (eg. John)',
        placeholderLastName: 'Last Name (eg. Doe)',
        placeholderPhone: 'Phone (eg. 2102 0888)',
        nameRequired: 'Name and Salutation are required',
        emailRequired: 'Email is required',
        phoneRequired: 'Phone Code and Number are required',
    },
    t: {
        nameEdit: 'Edit',
        nameDeleteAccount: 'Delete Account',
        nameConnectedWith: 'Connected With',
        nameFacebook: 'Facebook',
        nameBirthday: 'Birthday',
        nameMemberSince: 'Member Since',
        nameName: 'Name',
        nameCurrency: 'Currency',
        nameEmail: 'Email',
        nameLanguage: 'Language',
        namePhone: 'Phone',
        nameNA: 'Not Provided',
        nameCancel: 'Cancel',
        nameUpdate: 'Update',
        nameSalutation: 'Salutation',
    },
    currencyOptions: LayoutState_init_1.defaultLayoutState.currencies.options,
    languageMap: LayoutState_init_1.defaultLayoutState.language.languages,
    days: LayoutState_init_1.defaultLayoutState.days,
    months: LayoutState_init_1.defaultLayoutState.months,
    years: LayoutState_init_1.defaultLayoutState.years,
};
